import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button } from '@mui/material';
import axios from 'axios';

const NewsManagement = () => {
  const [newsList, setNewsList] = useState([]);
  const [headline, setHeadline] = useState('');
  const [summary, setSummary] = useState('');
  const token = localStorage.getItem('token');

  const fetchNews = () => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/news`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setNewsList(res.data))
      .catch((err) => console.error('Fetch news error:', err));
  };

  useEffect(() => {
    fetchNews();
  }, []);

  const addNews = () => {
    if (!headline || !summary) return;
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/news`,
        { headline, summary },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(() => {
        setHeadline('');
        setSummary('');
        fetchNews();
      })
      .catch((err) => console.error('Add news error:', err));
  };

  const deleteNews = (id) => {
    axios
      .delete(`${process.env.REACT_APP_API_BASE_URL}/api/admin/news/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => fetchNews())
      .catch((err) => console.error('Delete news error:', err));
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>News</Typography>
      <TextField
        label="Headline"
        value={headline}
        onChange={(e) => setHeadline(e.target.value)}
        fullWidth
        margin="dense"
      />
      <TextField
        label="Summary"
        value={summary}
        onChange={(e) => setSummary(e.target.value)}
        fullWidth
        margin="dense"
        multiline
      />
      <Button onClick={addNews} variant="contained" sx={{ mt: 1 }}>Add News</Button>

      <ul style={{ marginTop: '1rem' }}>
        {newsList.map((item) => (
          <li key={item.id}>
            <strong>{item.headline}</strong><br />
            {item.summary}<br />
            <small>By {item.createdBy} on {new Date(item.createdDate).toLocaleDateString()}</small>
            <Button
              variant="text"
              color="error"
              size="small"
              onClick={() => deleteNews(item.id)}
              sx={{ ml: 1 }}
            >
              Delete
            </Button>
          </li>
        ))}
      </ul>
    </Box>
  );
};

export default NewsManagement;
